// (C) Copyright 2025 Hewlett Packard Enterprise Development LP
import React from 'react'
import { Route, Routes, useNavigate, useLocation } from 'react-router-dom'

import { checkGotoChooseAccount } from '../../../utils/common-utils'

import SsoConfigurationsPage from './SsoConfigurationsPage'
import CreateAuthPolicyWizard from './create-auth-policy/CreateAuthPolicyWizard'
import AddSsoConnection from './components/add-sso-connection/AddSsoConnectionWizard'

const SsoConfigurationsRouter = () => {
  const navigate = useNavigate()
  const location = useLocation()
  checkGotoChooseAccount(navigate, location)

  return (
    <Routes>
      <Route exact path="/" element={<SsoConfigurationsPage />} />
      <Route
        exact
        path="/sso-connections/add-sso-connection"
        element={<AddSsoConnection />}
      />
      <Route
        exact
        path="/sso-connections/create-auth-policy"
        element={<CreateAuthPolicyWizard />}
      />
    </Routes>
  )
}

export default SsoConfigurationsRouter
